import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import { Input } from "stories/forms";

const inputOptions = [
  {key: 2, value: "Ei palkkiota"},
  {key: 3, value: "Vain peruspalkkio 8€"},
  {key: 4, value: "8€ + palkkio 0,25%"},
]

const CommissionSelect = ({label, name="commission", onChange, value, disabled, allOption = true}) => {
  const { t } = useTranslation();
  
  const getInputOptions = useCallback(() => {
    return inputOptions && inputOptions.map(obj => {
      return (
        <option value={obj.key}>{obj.value}</option>
      )
    })
  }, [inputOptions])
  
  return (
    <Input label={label || label==="" ? label : t("commission_select_label","Palkkio")} type="select" disabled={disabled} name={name} onChange={onChange} value={value}>
      { allOption && (
        <option value="">{t("Kaikki")}</option>
      )}
      {getInputOptions()}
    </Input>
  )
  
  
}


export default CommissionSelect;